<template>
    <span class="text-xs text-gray-500 md:ml-2">
        Last updated: {{ lastUpdated }}
        <sup class="-ml-1">
            <Tooltip
                text="The availability data that is presented is refreshed periodically and might not be 100% up to date. Please verify availability with the hotel prior to transferring any points."
            />
        </sup>
    </span>
</template>

<script>
import { computed } from 'vue';
import { useCalendarStore } from '@/store/calendar';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Tooltip from '@/components/tooltip.vue';

export default {
    components: {
        Tooltip,
    },
    setup() {
        dayjs.extend(relativeTime);
        const calendarStore = useCalendarStore();

        const lastUpdated = computed(() => {
            return dayjs(calendarStore.last_updated).fromNow();
        });

        return { lastUpdated };
    },
};
</script>
